module.exports = __webpack_public_path__ + "static/media/gif_absenteismo.34cb96ff.gif";